var render = function render(){var _vm=this,_c=_vm._self._c;return _c('node-view-wrapper',{class:_vm.className,attrs:{"data-id":_vm.uuid}},[_c('node-view-content',{class:`${_vm.className}__content`,attrs:{"as":"div"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }